import { useState } from "react";
import { CATEGORIAS, getTipoCategoria } from '../constants/formConfig';
import { exportPDF } from '../utils/pdfExport';
import supabase from '../supabaseClient';
import { TarjetaRegistro } from './TarjetaRegistro';
import { FiltroCategorias } from './FiltroCategorias';

// ── ADMIN: PENDIENTES ────────────────────────────────────────────
export const PendientesSection = ({ historial, loading, cargarHistorial, setLlegadas, almacen_id, onValidar, onRechazar }) => {
  const [filtroPendientes, setFiltroPendientes] = useState("Todas");

  const pendientesFiltrados = historial.filter(r => filtroPendientes === "Todas" || getTipoCategoria(r.tipo) === filtroPendientes);
  const countsPendientes = CATEGORIAS.reduce((acc, cat) => {
    acc[cat] = cat === "Todas" ? historial.length : historial.filter(r => getTipoCategoria(r.tipo) === cat).length;
    return acc;
  }, {});

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="font-bold text-gray-800">📋 Formularios pendientes</h2>
        <button onClick={async () => {
  cargarHistorial();
  const { data } = await supabase.from('registro_llegadas').select('*').eq('almacen_id', almacen_id).order('created_at', { ascending: false });
  setLlegadas(data || []);
}} className="text-xs bg-green-50 text-green-600 px-2 py-1 rounded-lg border border-green-200">🔄 Actualizar</button>
      </div>
      <FiltroCategorias filtro={filtroPendientes} setFiltro={setFiltroPendientes} counts={countsPendientes} />
      {loading && <div className="bg-white rounded-xl shadow p-6 text-center text-gray-400 text-sm">⏳ Cargando...</div>}
      {!loading && pendientesFiltrados.length === 0 && (
        <div className="bg-white rounded-xl shadow p-8 text-center text-gray-400">
          <p className="text-4xl mb-2">✅</p>
          <p className="text-sm">{filtroPendientes === "Todas" ? "No hay formularios pendientes." : `No hay pendientes en la categoría "${filtroPendientes}".`}</p>
        </div>
      )}

      {pendientesFiltrados.map(r => (
        <TarjetaRegistro key={r.id} r={r} esAdmin={true} onValidar={onValidar} onRechazar={onRechazar} onExport={exportPDF} />
      ))}
    </div>
  );
};
